// @ts-ignore
import {
  AggregationBaseKey,
  AggregationFilters,
  Aggregations,
  AggregationTranslation,
  AggregationTranslationValue,
} from '@/types/virtual-search/filters';

export const getFilterOptionsFromAggregations = (aggregations: Aggregations) => {
  const keys = Object.keys(aggregations);
  return keys.reduce((acc, key) => {
    return {
      ...acc,
      [key]: { value: key, label: '', type: key.includes('keyword') ? 'select' : 'boolean' },
    };
  }, {});
};

export const reduceAggregationFilterValues = (
  aggregations: Aggregations,
  omit: AggregationBaseKey[] = []
): AggregationFilters => {
  if (!aggregations) return {};

  const keys = Object.keys(aggregations) as AggregationBaseKey[];

  return keys.reduce<AggregationFilters>((acc, query) => {
    if (!omit.includes(query)) acc[query] = aggregations[query]?.buckets ?? [];
    return acc;
  }, {});
};

export const reduceAggregationFilterOptions = (
  aggregations: Aggregations,
  translations: AggregationTranslation,
  additionalOptions?: AggregationTranslation
) => {
  if (!aggregations) return {};

  const keys = Object.keys(aggregations) as AggregationBaseKey[];

  const filteredOptions = keys.reduce<Partial<AggregationTranslation>>((acc, query) => {
    const translation = translations[query];

    if (translation) acc[query] = translation;

    return acc;
  }, {});

  return { ...filteredOptions, ...additionalOptions };
};

export const filterInitialSelectedFilters = (
  initialForm: Record<string, unknown>,
  translations: AggregationTranslation
) => {
  const keys = Object.keys(initialForm) as (keyof typeof translations)[];

  return keys.reduce<AggregationTranslationValue[]>((acc, key) => {
    const translation = translations?.[key];

    if (translation) acc.push(translation);

    return acc;
  }, []);
};

export const formatAggregationFilters = (filters: { [key: string]: unknown }) => {
  const keys = Object.keys(filters);

  return keys.reduce<{
    [key: string]: unknown;
  }>((acc, key) => {
    const value = filters[key];

    if (!value || (Array.isArray(value) && !value?.length)) return acc;

    acc[key] = filters[key];
    return acc;
  }, {});
};
